import { IDLE } from "_constants/redux.constants";

const initialPhototoolState = {
  pc9: {
    data: null,
    error: null,
    status: IDLE
  }
};

export default initialPhototoolState;
